const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.638,7.146l-1.3-1.3a1.266,1.266,0,0,0-1.75,0,.238.238,0,0,1-.337,0L4.159,3.755a.239.239,0,0,1,0-.336,1.237,1.237,0,0,0,0-1.751l-1.3-1.3a1.24,1.24,0,0,0-1.75,0L.8.674a2.715,2.715,0,0,0-.367,3.38,20.387,20.387,0,0,0,5.519,5.52,2.729,2.729,0,0,0,3.381-.368l.31-.309A1.241,1.241,0,0,0,9.638,7.146Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
